import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { TeamMember } from '../../../../core/models/mysec/team-member';
import { TeamsService } from '../../../../core/services/api/mysec/teams.service';
import { DefaultProfileImage } from '../../../../core/services/constant';
import { ErrorService } from '../../../../core/services/error.service';
import { BlockUiService } from '../../../../shared/services/blockUi/block-ui.service';
import { PopupService } from '../../../../shared/services/popup/popup.service';

@Component({
    selector: 'app-team-management',
    templateUrl: './team-management.component.html',
    styleUrls: ['./team-management.component.scss'],
    standalone: false
})
export class TeamManagementComponent implements OnInit {
  isLoading = false;
  teams: TeamMember[];
  defaultProfileImage = DefaultProfileImage;

  constructor(
    private teamsService: TeamsService,
    private errorService: ErrorService,
    private popupService: PopupService,
    private blockUiService: BlockUiService,
  ) {}

  ngOnInit() {
    this.getTeams();
  }

  getTeams() {
    this.isLoading = true;

    this.teamsService
      .getTeams()
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        (data) => {
          this.teams = data;
        },
        (err) => {
          this.errorService.showError(err);
        },
      );
  }

  delete(mySecCompanyTeamId: number) {
    this.popupService.confirm('mysec.deleteTeamMessage').then(
      () => {
        this.blockUiService.open();

        this.teamsService
          .deleteTeamMember(mySecCompanyTeamId)
          .pipe(finalize(() => this.blockUiService.close()))
          .subscribe(
            () => {
              this.getTeams();
            },
            (err) => {
              this.errorService.showError(err);
            },
          );
      },
      () => {},
    );
  }
}
